import React from "react";
//import footerCss from "../../../css/mainLayout/footer/footer.css";
export default class Footer extends React.Component{
   constructor(props){
      super(props);
   }
   render(){
      return(
         <footer className="sticky-footer bg-dark text-center text-small">
         <p className="mb-1 text-white">© {new Date().getFullYear()} NORDCOM. All rights reserved</p>
         <ul className="list-inline">
           <li className="list-inline-item text-white "><a href="#/Privacy">Privacy</a></li>
           <li className="list-inline-item text-white"><a href="#/Terms">Terms</a></li>
           <li className="list-inline-item text-white"><a href="#/ricercaSanzione">Ricerca Sanzione</a></li>
         </ul>
       </footer>
      );
   }
}